import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'ONLINE_BAND_GET_ALL',
  GET_ALL_SUCCESS: 'ONLINE_BAND_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ONLINE_BAND_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(() => `${BASE_URL}/pricing/online-bands/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
